import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import PropTypes from 'prop-types'
import { CssBaseline, ThemeProvider } from '@mui/material'
import Error from 'components/Error'
import { useDynamicManageStore } from 'store/useDynamicManageStore'
import 'styles/index.scss'
import { lightTheme } from 'themes/theme'
import 'i18n/i18n'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            useErrorBoundary: true,
            cacheTime: 0
        },
        mutations: {
            useErrorBoundary: true
        }
    }
})

queryClient.getQueryCache().subscribe((event) => {
    if (event?.type === 'observerResultsUpdated') {
        event.query?.invalidate()
    }
})

const maintenanceState = window.maintenance

function App({ children, ...props }) {
    const setDynamicManageData = useDynamicManageStore((state) => state.setDynamicManageData)
    setDynamicManageData({
        maintenance: maintenanceState,
        ...props
    })

    return (
        <ThemeProvider theme={lightTheme}>
            <CssBaseline />
            <QueryClientProvider client={queryClient}>
                <ErrorBoundary fallback={<Error />}>{children}</ErrorBoundary>
            </QueryClientProvider>
        </ThemeProvider>
    )
}

App.propTypes = {
    children: PropTypes.node
}

export default App
